import { render, staticRenderFns } from "./Reviewslist.vue?vue&type=template&id=d488acd2&scoped=true"
import script from "./Reviewslist.vue?vue&type=script&lang=js"
export * from "./Reviewslist.vue?vue&type=script&lang=js"
import style0 from "./Reviewslist.vue?vue&type=style&index=0&id=d488acd2&prod&lang=css"
import style1 from "./Reviewslist.vue?vue&type=style&index=1&id=d488acd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d488acd2",
  null
  
)

export default component.exports